import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Icon from '@mdi/react';
import { mdiHome, mdiArrowLeft } from '@mdi/js';
import { Container } from '../ui/Container';
import { Button } from '../ui/Button';
import { PageHead } from '../seo';

const PageWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-12) 0;
`;

const Content = styled.div`
  text-align: center;
  max-width: 500px;
`;

const ErrorCode = styled.h1`
  font-size: clamp(6rem, 20vw, 10rem);
  font-weight: var(--font-bold);
  background: linear-gradient(135deg, var(--color-brand-primary), var(--color-brand-secondary));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  line-height: 1;
  margin-bottom: var(--space-4);
`;

const Title = styled.h2`
  font-size: var(--text-2xl);
  margin-bottom: var(--space-4);
`;

const Description = styled.p`
  font-size: var(--text-lg);
  color: var(--color-text-secondary);
  margin-bottom: var(--space-8);
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: var(--space-4);
  justify-content: center;
  flex-wrap: wrap;
`;

export function NotFound() {
  return (
    <PageWrapper>
      <PageHead
        title="Page Not Found"
        description="The page you're looking for doesn't exist or has been moved."
        noindex
      />
      <Container>
        <Content>
          <ErrorCode>404</ErrorCode>
          <Title>Page Not Found</Title>
          <Description>
            Oops! The page you're looking for doesn't exist or has been moved.
          </Description>
          <ButtonGroup>
            <Button as={Link} to="/">
              <Icon path={mdiHome} size={0.9} />
              Go Home
            </Button>
            <Button
              variant="secondary"
              onClick={() => window.history.back()}
            >
              <Icon path={mdiArrowLeft} size={0.9} />
              Go Back
            </Button>
          </ButtonGroup>
        </Content>
      </Container>
    </PageWrapper>
  );
}

export default NotFound;
